import { useEffect } from 'react'
import AOS from 'aos'
import 'aos/dist/aos.css'

import { Section } from '../../components/Section'
import { SolutionsPhrases } from '../../components/Solucoes/SolutionsPhrases'
import { SolutionsPhrasesMobile } from '../../components/Solucoes/SolutionsPhrasesMobile'
import { SolutionsDescription } from '../../components/Solucoes/SolutionsDescription'
import { SolutionsDescriptionMobile } from '../../components/Solucoes/SolutionsDescriptionMobile'

import solution1 from '../../assets/solucoes/solucoes_1.jpg'
import solution2 from '../../assets/solucoes/solucoes_2.jpg'
import solution2Mobile from '../../assets/solucoes/solucoes_2_tablet.jpg'
import solution3 from '../../assets/solucoes/solucoes_3.jpg'
import solution3Mobile from '../../assets/solucoes/solucoes_3_tablet.jpg'
import solution4 from '../../assets/solucoes/solucoes_4.jpg'
import solution4Mobile from '../../assets/solucoes/solucoes_4_tablet.jpg'
import solution5 from '../../assets/solucoes/solucoes_5.jpg'
import solution5Mobile from '../../assets/solucoes/solucoes_5_tablet.jpg'
import solution6 from '../../assets/solucoes/solucoes_6.jpg'
import solution6Mobile from '../../assets/solucoes/solucoes_6_tablet.jpg'

export function Solucoes() {
 useEffect(() => {
  AOS.init()
 }, [])

 return (
  <Section id="solucoes" title="Soluções" className="py-20">
   <div className="container">
    <div className="flex flex-col min-[576px]:flex-row gap-4 min-[992px]:h-[709px]">
     <div className="w-full sm:w-1/2 lg:w-1/2">
      <div className="min-[1200px]:w-[495px] h-[410px] block max-[992px]:hidden">
       <div className="w-full h-full" data-aos="fade-right">
        <img
         src={solution1}
         alt="Campanha"
         width={411}
         height={410}
         loading="eager"
         decoding="async"
         fetchPriority="high"
        />
        <SolutionsPhrases
         width="132"
         bottom="0"
         right="0"
         syllable1="CAM"
         syllable2="PA"
         syllable3="NHA"
        />
        <SolutionsDescription
         animation="fadeInDown"
         bottom="130"
         right="-253"
         maxWidth="289"
         description="A mensagem certa, na hora certa, no lugar certo. A estratégia, o planejamento e a criação colocados em prática: na web, nas ruas e em todos os lugares onde o seu público está."
        />
       </div>
      </div>
      <div
       className="hidden max-[992px]:block relative max-[574px]:top-0 top-[14px]"
       data-aos="fade-right"
      >
       <img src={solution1} alt="Campanha" />
       <div className="p-4">
        <SolutionsPhrasesMobile
         syllable1="CAM"
         syllable2="PA"
         syllable3="NHA"
        />
        <SolutionsDescriptionMobile description="A mensagem certa, na hora certa, no lugar certo. A estratégia, o planejamento e a criação colocados em prática: na web, nas ruas e em todos os lugares onde o seu público está." />
       </div>
      </div>
     </div>
     <div className="w-full sm:w-1/2 lg:w-1/2 relative">
      <div className="w-[411px] h-[410px] block max-[992px]:hidden bottom-[100px] right-0 absolute">
       <div className="w-full h-full" data-aos="fade-left">
        <img
         src={solution2}
         alt="Digital Performance"
         width={411}
         height={410}
         loading="eager"
         decoding="async"
         fetchPriority="high"
        />
        <SolutionsPhrases
         width="339"
         bottom="12"
         right="220"
         syllable1="DIGITAL"
         syllable2="PERFORMANCE"
        />
        <SolutionsDescription
         animation="fadeInUp"
         bottom="-100"
         right="0"
         left="-94"
         maxWidth="367"
         description="Planejamento, gestão e otimização de mídia com foco em resultado. Tudo isso com base em análises aprofundadas e estratégias personalizadas de acordo com o cenário e objetivo de cada empresa."
        />
       </div>
      </div>
      <div className="hidden max-[992px]:block" data-aos="fade-left">
       <div className="hidden min-[574px]:block">
        <img src={solution2} alt="Digital Performance" />
       </div>
       <div className="hidden max-[574px]:block">
        <img src={solution2Mobile} alt="Digital Performance" />
       </div>
       <div className="p-4">
        <SolutionsPhrasesMobile syllable1="DIGITAL" syllable2="PERFORMANCE" />
        <SolutionsDescriptionMobile description="Planejamento, gestão e otimização de mídia com foco em resultado. Tudo isso com base em análises aprofundadas e estratégias personalizadas de acordo com o cenário e objetivo de cada empresa." />
       </div>
      </div>
     </div>
    </div>
    <div className="flex flex-col min-[576px]:flex-row gap-4 min-[992px]:h-[709px]">
     <div className="w-full sm:w-1/2 lg:w-1/2">
      <div className="min-[1200px]:w-[495px] h-[410px] block max-[992px]:hidden">
       <div className="w-full h-full" data-aos="fade-right">
        <img
         src={solution3}
         alt="Branding"
         width={411}
         height={410}
         loading="eager"
         decoding="async"
         fetchPriority="high"
        />
        <SolutionsPhrases
         width="164"
         bottom="-38"
         right="185"
         syllable1="BRAND"
         syllable2="ING"
        />
        <SolutionsDescription
         animation="fadeInUp"
         bottom="-164"
         left="111"
         maxWidth="289"
         description="Posicionamento e reposicionamento de marca. Seja qual for o tamanho da sua empresa, construir uma sólida estratégia de marca é uma importante vantagem competitiva."
        />
       </div>
      </div>
      <div className="hidden max-[992px]:block" data-aos="fade-right">
       <div className="hidden min-[574px]:block">
        <img src={solution3} alt="Branding" />
       </div>
       <div className="hidden max-[574px]:block">
        <img src={solution3Mobile} alt="Branding" />
       </div>
       <div className="p-4">
        <SolutionsPhrasesMobile syllable1="BRAND" syllable2="ING" />
        <SolutionsDescriptionMobile description="Posicionamento e reposicionamento de marca. Seja qual for o tamanho da sua empresa, construir uma sólida estratégia de marca é uma importante vantagem competitiva." />
       </div>
      </div>
     </div>
     <div className="w-full sm:w-1/2 lg:w-1/2 relative">
      <div className="w-[411px] h-[410px] block max-[992px]:hidden top-[100px] right-0 absolute">
       <div className="w-full h-full" data-aos="fade-left">
        <img
         src={solution4}
         alt="Social Media"
         width={411}
         height={410}
         loading="eager"
         decoding="async"
         fetchPriority="high"
        />
        <SolutionsPhrases
         width="164"
         bottom="-28"
         right="114"
         syllable1="SOCIAL"
         syllable2="MEDIA"
        />
        <SolutionsDescription
         animation="fadeInUp"
         bottom="-159"
         right="0"
         left="182"
         maxWidth="367"
         description="Conectar pessoas e marcas. Estabelecer relações, conversas e conexões entre a sua empresa e o seu público com estratégias digitais baseadas em conteúdo."
        />
       </div>
      </div>
      <div className="hidden max-[992px]:block" data-aos="fade-left">
       <div className="hidden min-[574px]:block">
        <img src={solution4} alt="Social Media" />
       </div>
       <div className="hidden max-[574px]:block">
        <img src={solution4Mobile} alt="Social Media" />
       </div>
       <div className="p-4">
        <SolutionsPhrasesMobile syllable1="SOCIAL" syllable2="MEDIA" />
        <SolutionsDescriptionMobile description="Conectar pessoas e marcas. Estabelecer relações, conversas e conexões entre a sua empresa e o seu público com estratégias digitais baseadas em conteúdo." />
       </div>
      </div>
     </div>
    </div>
    <div className="flex flex-col min-[576px]:flex-row gap-4 min-[992px]:h-[709px]">
     <div className="w-full sm:w-1/2 lg:w-1/2">
      <div className="min-[1200px]:w-[495px] h-[410px] block max-[992px]:hidden">
       <div className="w-full h-full" data-aos="fade-right">
        <img
         src={solution5}
         alt="Digital Solution"
         width={411}
         height={410}
         loading="eager"
         decoding="async"
         fetchPriority="high"
        />
        <SolutionsPhrases
         width="233"
         bottom="292"
         right="-12"
         syllable1="DIGITAL"
         syllable2="SOLUTION"
        />
        <SolutionsDescription
         animation="fadeInUp"
         bottom="10"
         right="-69"
         maxWidth="289"
         description="E-commerce e sites institucionais personalizados de acordo com o que seu negócio precisa, além de CMS (Content Management System) também criado sob medida."
        />
       </div>
      </div>
      <div className="hidden max-[992px]:block relative" data-aos="fade-right">
       <div className="hidden min-[574px]:block">
        <img src={solution5} alt="Digital Solution" />
       </div>
       <div className="hidden max-[574px]:block">
        <img src={solution5Mobile} alt="Digital Solution" />
       </div>
       <div className="p-4">
        <SolutionsPhrasesMobile syllable1="DIGITAL" syllable2="SOLUTION" />
        <SolutionsDescriptionMobile description="E-commerce e sites institucionais personalizados de acordo com o que seu negócio precisa, além de CMS (Content Management System) também criado sob medida." />
       </div>
      </div>
     </div>
     <div className="w-full sm:w-1/2 lg:w-1/2 relative">
      <div className="w-[411px] h-[410px] block max-[992px]:hidden bottom-[100px] right-0 absolute">
       <div className="w-full h-full" data-aos="fade-left">
        <img
         src={solution6}
         alt="Endo Marketing"
         width={411}
         height={410}
         loading="eager"
         decoding="async"
         fetchPriority="high"
        />
        <SolutionsPhrases
         width="282"
         bottom="0"
         right="172"
         syllable1="ENDO"
         syllable2="MARKETING"
        />
        <SolutionsDescription
         animation="fadeInUp"
         bottom="-89"
         right="0"
         left="32"
         maxWidth="367"
         description="Produção de conteúdo e projetos customizados para o público interno, além de ações de incentivo para conectar colaboradores e gerar resultados."
        />
       </div>
      </div>
      <div className="hidden max-[992px]:block" data-aos="fade-left">
       <div className="hidden min-[574px]:block">
        <img src={solution6} alt="Endo Marketing" />
       </div>
       <div className="hidden max-[574px]:block">
        <img src={solution6Mobile} alt="Endo Marketing" />
       </div>
       <div className="p-4">
        <SolutionsPhrasesMobile syllable1="ENDO" syllable2="MARKETING" />
        <SolutionsDescriptionMobile description="Produção de conteúdo e projetos customizados para o público interno, além de ações de incentivo para conectar colaboradores e gerar resultados." />
       </div>
      </div>
     </div>
    </div>
    <div className="flex flex-col min-[576px]:flex-col min-[992px]:gap-4 top-[40px] relative">
     <h4 className="font-['rns-milesblack'] font-bold min-[768px]:text-[18px] min-[992px]:text-[35px] text-[var(--text-main)] min-[992px]:leading-[40px] min-[992px]:max-w-[222px] relative z-10 min-[992px]:left-[100px] min-[1200px]:left-[125px]">
      E aí, vamos tomar um café e falar sobre o que você precisa?
     </h4>
     <div className="bg-[var(--primary-yellow)] min-[992px]:py-2.5 min-[992px]:pl-6 min-[992px]:pr-[5px] relative min-[992px]:top-[-30px] z-0 min-[992px]:w-[80%] mx-auto">
      <p className="font-['rns-milesregular'] font-normal min-[768px]:text-[15px] min-[992px]:text-[17px] text-[var(--solucoes-footer)]">
       Queremos conhecer você e sua empresa, conversar mais sobre o seu negócio
       e compartilhar nossos pensamentos, filosofia de trabalho e onde podemos
       conduzir e cuidar da sua marca. Vamos falar! 55 11 3619 3084
      </p>
     </div>
    </div>
   </div>
  </Section>
 )
}
